module.exports = __webpack_public_path__ + "static/media/pic8.82a96891.jpg";